export const GET_SEJOURS_MODELS = "sejours/GET_SEJOURS_MODELS";
export const DELETE_SEJOURS_MODELS = "sejours/DELETE_SEJOURS_MODELS";